import { connect } from 'react-redux';
import { isFromMobileApp } from '@app/components/purchase_flow/utils/paymentSupportUtils';
import ZendeskMessagingProvider from './zendesk_messaging_provider';

const mobileApp = isFromMobileApp();

const mapStateToProps = ({
  user,
  application
}: {
  user: { user?: User.Details | null };
  application: { dynamicConfig?: Application.DynamicConfig };
}) => {
  if (mobileApp) {
    return { zendeskConfig: null };
  }

  const channelKey = application.dynamicConfig?.zendeskSettings?.channelKey ?? null;
  const userZendeskConfig = user?.user?.zendeskConfig;

  const jwtToken = userZendeskConfig?.jwtToken ?? '';

  return {
    zendeskConfig: channelKey && jwtToken ? {
      channelKey,
      jwtToken,
      tags: userZendeskConfig?.tags ?? []
    } : null
  };
};

export default connect(mapStateToProps)(ZendeskMessagingProvider);

export { useZendeskMessaging } from './useZendeskMessaging';
export type { ZendeskMessagingHookResult } from './types';
